export default __webpack_public_path__ + "static/6617-504a800d08984345521a40528f51ecf7.jpg";